import { Row, Column } from '@react-email/components';

const Divider = ({
  style = {},
  className = '',
}: {
  style?: React.CSSProperties;
  className?: string;
}) => (
  <Row>
    <Column>
      <div
        style={{
          height: '1px',
          backgroundColor: '#0000001A',
          width: '100%',
          display: 'block',
          ...style,
        }}
        className={className}
      />
    </Column>
  </Row>
);

export default Divider;
